import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../Constant/colors";
import { hasPermission } from "../utils/permissionUtils";

const StudentManagement = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: "white",
    padding: "20px",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    transition: "0.3s",
    display: "flex",
    alignItems: "center",
    gap: "16px",
    minHeight: "120px",
    height: "100%",
  };

  const iconStyle = { fontSize: "32px" };
  const titleStyle = { color: colors.grayDark };
  const descStyle = { color: colors.grayDark };

  return (
    <div className="flex justify-center items-start p-6 bg-white min-h-screen">
      <div className="w-full max-w-7xl">


        {/* ================== CARDS ================== */}
        <div className={`grid gap-6 ${isMobile ? "grid-cols-1" : "grid-cols-3"}`}>

          {hasPermission("enroll_student") && (
            <Link to="/new-student" className="flex">
              <div style={cardStyle} className="hover:scale-105 w-full">
                <i className="fas fa-user-plus" style={{ ...iconStyle, color: "#FF8F00" }} />
                <div>
                  <h2 className="text-lg font-semibold" style={titleStyle}>Enroll New Student</h2>
                  <p className="text-sm opacity-85" style={descStyle}>Add new students to the system.</p>
                </div>
              </div>
            </Link>
          )}

          {hasPermission("update_student") && (
            <Link to="/student-table" className="flex">
              <div style={cardStyle} className="hover:scale-105 w-full">
                <i className="fas fa-user-edit" style={{ ...iconStyle, color: "#FF3B30" }} />
                <div>
                  <h2 className="text-lg font-semibold" style={titleStyle}>Update Student Information</h2>
                  <p className="text-sm opacity-85" style={descStyle}>Edit student details.</p>
                </div>
              </div>
            </Link>
          )}

          {hasPermission("enroll_guardian") && (
            <Link to="/enroll-guardian" className="flex">
              <div style={cardStyle} className="hover:scale-105 w-full">
                <i className="fas fa-users" style={{ ...iconStyle, color: "blueviolet" }} />
                <div>
                  <h2 className="text-lg font-semibold" style={titleStyle}>Enroll Guardian</h2>
                  <p className="text-sm opacity-85" style={descStyle}>Add guardians and their details.</p>
                </div>
              </div>
            </Link>
          )}

          {hasPermission("issue_gate_pass") && (
            <Link to="/gatepass-management" className="flex">
              <div style={cardStyle} className="hover:scale-105 w-full">
                <i className="fas fa-door-open" style={{ ...iconStyle, color: "#7A3FF1" }} />
                <div>
                  <h2 className="text-lg font-semibold" style={titleStyle}>Issue Gatepass</h2>
                  <p className="text-sm opacity-85" style={descStyle}>Issue and manage student gatepasses.</p>
                </div>
              </div>
            </Link>
          )}

          {hasPermission("manage_student_attendance") && (
            <Link to="/student-attendance" className="flex">
              <div style={cardStyle} className="hover:scale-105 w-full">
                <i className="fas fa-calendar-check" style={{ ...iconStyle, color: "#06B6D4" }} />
                <div>
                  <h2 className="text-lg font-semibold" style={titleStyle}>Manage Student Attendance</h2>
                  <p className="text-sm opacity-85" style={descStyle}>Track and manage daily attendance.</p>
                </div>
              </div>
            </Link>
          )}

          {hasPermission("classes") && (
            <Link to="/class-management" className="flex">
              <div style={cardStyle} className="hover:scale-105 w-full">
                <i className="fas fa-school" style={{ ...iconStyle, color: "#39FF14" }} />
                <div>
                  <h2 className="text-lg font-semibold" style={titleStyle}>Classes</h2>
                  <p className="text-sm opacity-85" style={descStyle}>Manage class schedules, subjects, and structure.</p>
                </div>
              </div>
            </Link>
          )}

          {hasPermission("homework_assignment") && (
            <Link to="/homework-assignments" className="flex">
              <div style={cardStyle} className="hover:scale-105 w-full">
                <i className="fas fa-book" style={{ ...iconStyle, color: "#3B82F6" }} />
                <div>
                  <h2 className="text-lg font-semibold" style={titleStyle}>Homework & Assignments</h2>
                  <p className="text-sm opacity-85" style={descStyle}>Manage homework and assignment details.</p>
                </div>
              </div>
            </Link>
          )}

          {hasPermission("student_certificate") && (
            <Link to="/student-certificates" className="flex">
              <div style={cardStyle} className="hover:scale-105 w-full">
                <i className="fas fa-award" style={{ ...iconStyle, color: colors.primary }} />
                <div>
                  <h2 className="text-lg font-semibold" style={titleStyle}>Student Certificates</h2>
                  <p className="text-sm opacity-85" style={descStyle}>View and manage student certificates.</p>
                </div>
              </div>
            </Link>
          )}

          {hasPermission("bulk_upload_students") && (
            <Link to="/bulk-upload" className="flex">
              <div style={cardStyle} className="hover:scale-105 w-full">
                <i className="fas fa-file-excel" style={{ ...iconStyle, color: "#2E7D32" }} />
                <div>
                  <h2 className="text-lg font-semibold" style={titleStyle}>Bulk Upload Students</h2>
                  <p className="text-sm opacity-85" style={descStyle}>Upload multiple students from Excel or CSV.</p>
                </div>
              </div>
            </Link>
          )}

        </div>
      </div>
    </div>
  );
};

export default StudentManagement;
